import React, { ReactElement } from 'react';

export const InternalLinkTestId = 'internallink-input';

export type InternalLinkProps = {
  children: (ReactElement | string)[] | ReactElement | string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  testId?: string;
};

const InternalLink: React.FC<InternalLinkProps> = ({
  children,
  onClick,
  className = '',
  testId,
}: InternalLinkProps) => {
  const classes = `${className} link-input outline-none focus:outline-none text-sm`;

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      data-testid={testId || InternalLinkTestId}
    >
      {children}
    </button>
  );
};

export default InternalLink;
